export function LoadingScreen() {
  return (
    <div className="container loading">
      <div className="spinner" />
      <p>Loading BubblaV...</p>
    </div>
  );
}
